import { useState, useEffect } from 'react';
import { getAnnonces } from 'src/service/annonceApi';
import { useNotification } from 'src/contexts/NotificationContext';

export const useRestitutedCount = () => {
  const [restitutedCount, setRestitutedCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const { refreshTrigger } = useNotification();

  const fetchRestitutedCount = async () => {
    try {
      const annonces = await getAnnonces('?status=RESTITUÉ');
      setRestitutedCount(annonces.length || 0);
    } catch (error) {
      console.error('Erreur lors de la récupération du nombre d\'objets restitués:', error);
      setRestitutedCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRestitutedCount();
    
    // Rafraîchir toutes les 30 secondes
    const interval = setInterval(fetchRestitutedCount, 30000);
    
    return () => clearInterval(interval);
  }, [refreshTrigger]); // Ajouter refreshTrigger comme dépendance

  return { restitutedCount, loading, refetch: fetchRestitutedCount };
}; 